/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React, { CSSProperties } from 'react';

const STYLE: CSSProperties = { color: 'red' };

const ValidationMessage = ({ children }: { children: string }) => <div style={STYLE}>{children}</div>;

export default ValidationMessage;
